// src/components/Stats.js
import React, { useEffect, useState } from 'react';
import { FaUsers, FaMicrophone, FaChalkboardTeacher, FaHandshake } from 'react-icons/fa';
import CountUp from 'react-countup'; 
import './Stats.css'; 

const Stats = () => {
  const [animate, setAnimate] = useState(false); 

  useEffect(() => {
    const animationDuration = 1000; 
    const timer = setTimeout(() => {
      setAnimate(true); 
    }, animationDuration);

    return () => clearTimeout(timer); 
  }, []);

  return (
    <div className="stats-overlay">
      <div className="stats-wrapper">
        
        {/* New VETEd AFRICA Title Section */}
        <div className="hero-title-section">
          <div className="veted-badge">
            <h1>2nd VET<span className="text-red">Ed</span> AFRICA</h1>
            <h2 className="congress-text">CONGRESS</h2>
          </div>
          
          {/* Corrected Subtitle Structure */}
          <h2 className="main-subtitle">
            <span className="text-white">Artificial Intelligence in veterinary education</span><br />
            <span className="text-cyan">Application and Impact</span>
          </h2>
          
          {/* Info Pills (Dates and Location) */}
          <div className="info-pills">
            <div className="pill">
              <span className="dot dot-red"></span> November 19-20-21, 2026
            </div>
            <div className="pill">
              <span className="dot dot-cyan"></span> IAV Hassan II Rabat Morocco
            </div>
          </div>
        </div>

        {/* Stats Section */}
        <div className="stats-container">
          <div className="stat-item">
            <FaUsers className="stat-icon" />
            <h2>{animate && <CountUp start={0} end={134} duration={4} />}+</h2>
            <p>Total Participants</p>
          </div>

          <div className="stat-item">
            <FaMicrophone className="stat-icon" />
            <h2>{animate && <CountUp start={0} end={5} duration={6} />}+</h2>
            <p>Keynote Speakers</p>
          </div>

          <div className="stat-item">
            <FaChalkboardTeacher className="stat-icon" />
            <h2>{animate && <CountUp start={0} end={26} duration={6} />}+</h2>
            <p>Oral & Poster Sessions</p>
          </div>

          <div className="stat-item">
            <FaHandshake className="stat-icon" />
            <h2>{animate && <CountUp start={0} end={7} duration={7} />}+</h2>
            <p>Sponsors</p>
          </div>
        </div>

      </div>
    </div>
  );
};

export default Stats;